const getEnv = (key) => (window._env_ && window._env_[key]) || process.env[key];

export const MAIN_SITE_EMBED_URL =
  getEnv('REACT_APP_MAIN_SITE_EMBED_URL') || '';
